<template>
  <img
    v-show="imagePreviewLoaded"
    :src="imagePreviewLoaded ? preview : undefined"
    alt=""
  />
</template>
<script>
import { loadingGalleryImageQueue } from '../loadingImageQueue'

export default {
  props: {
    preview: String
  },
  data() {
    return {
      imagePreviewLoaded: false,
    }
  },
  methods: {
    doLoadImagePreview() {
      console.log('adding image to loading queue', this.preview, loadingGalleryImageQueue)
      loadingGalleryImageQueue.add(() => {
        return new Promise((resolve) => {
          const image = new Image()
          image.onload = () => {
            resolve(this.imagePreviewLoaded = true)
          }

          image.onerror = () => {
            resolve()
            setTimeout(() => {
              if (this.doLoadImagePreview) {
                this.doLoadImagePreview()
              }
            }, 1000)
          }

          image.src = this.preview
        })
      })
    }
  },
  mounted() {
    this.doLoadImagePreview()
  },
}
</script>